import { from, Observable, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  ApplicationAction,
  ApplicationActions, CreateApplicationError,
  CreateApplicationRequest,
  CreateApplicationSuccess
} from '../actions/application.action';
import ApplicationService from '../services/application.service';
import { LoginSuccess } from '../actions';
import AuthUtils from '../../shared/utils/auth-utils';
import { ServerErrorMessages } from '../../shared/utils/server-error-utils';

const createApplicationEpic = (action$: Observable<ApplicationAction>) => action$.pipe(
  ofType<CreateApplicationRequest>(ApplicationActions.CreateApplicationRequest),
  switchMap((action) => from(ApplicationService.create(action.apiOptions)).pipe(
    map((response) =>
      new CreateApplicationSuccess(response),
    ),
    catchError((error) => of(
      new CreateApplicationError(ServerErrorMessages[error.message] || 'Sorry, we were unable to create your application, please try again.')
    ))
  )),
);

const createApplicationSuccessEpic = (action$: Observable<ApplicationAction>) => action$.pipe(
  ofType<CreateApplicationSuccess>(ApplicationActions.CreateApplicationSuccess),
  map(() =>
    new LoginSuccess({
      authed: true,
      sessionToken: AuthUtils.getAccessToken(),
      sessionTokenExpiration: new Date(AuthUtils.getAccessTokenExp()),
      errorText: '',
    }),
  ),
);

const ApplicationEpics = [
  createApplicationEpic,
  createApplicationSuccessEpic,
];

export default ApplicationEpics;
